module.exports = __webpack_public_path__ + "media/images/front/sp/for-doctors-refine/img_step02-f543c8ca725a900cbd7b1cdadbbadc1a.png";